<template>
  <v-app style="background-color: #F3F3F3;">
    <v-overlay :value="loading" class="align-center justify-center" z-index="9999">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <Sidebar
      v-if="showSidebar"
      @menu-action="handleMenuAction"
    />

    <v-main>
      <router-view ref="routerView"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from './components/layout/Sidebar.vue'

export default {
  name: "App",
  components: {
    Sidebar
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    showSidebar() {
      // Não mostrar sidebar na página de autenticação
      return this.$route.name !== 'Auth'
    }
  },
  methods: {
    handleMenuAction(action) {
      // Encaminhar ação para o componente Dashboard se existir
      const dashboardComponent = this.$refs.routerView?.$children?.[0]
      if (dashboardComponent && typeof dashboardComponent[action] === 'function') {
        dashboardComponent[action]()
      }
    },
    setGlobalLoading(value) {
      this.loading = value
    }
  },
  created() {
    // Escutar eventos de loading global
    this.$root.$on('global-loading', this.setGlobalLoading)

    if (this.isDesenvolvimento) {
      return;
    }

    if (!this.isRevenda) {
      return;
    }
  },
  beforeDestroy() {
    this.$root.$off('global-loading', this.setGlobalLoading)
  }
};
</script>

<style>
body {
  background-color: #F3F3F3;
}
</style>